export const SERVICE_AGREEMENT_PATH = '/legal/service-agreement';

export const SERVICE_AGREEMENT_ACCEPTANCE_TEXT =
  'I agree to the Shiplab Service Agreement and Terms of Service, and I confirm that I am authorized to agree on behalf of my organization.';

export type AgreementVersion = {
  agreement_type: string;
  version: string;
  content_html: string;
  content_sha256: string;
  is_current: boolean;
  created_at?: string | null;
};
